import { Button, Form, Modal } from 'antd'
import React from 'react'
import { useParams } from 'react-router'
import { useImportQuestionDefinitionMutation } from '../../../../../store/apis/developer-mode.api'
import Dragger from 'antd/es/upload/Dragger'
import { InboxOutlined } from '@ant-design/icons'

export const ImportQuestionDefinitionModal = ({ setShowExportQuestionDefinitionModal, question }) => {
    const { token } = useParams()
    const [form] = Form.useForm()

    const [importQuestionDefinition, importQuestionDefinitionResult] = useImportQuestionDefinitionMutation()

    const onClose = () => setShowExportQuestionDefinitionModal(false)

    const handleFinish = async ({ file }) => {
        await importQuestionDefinition({ file, token, questionId: question?.key })
        onClose()
    }

    const draggerProps = {
        name: 'file',
        accept: '.json',
        multiple: false,
        listType: 'picture',
        maxCount: 1,
        beforeUpload: () => false,
    }

    return (
        <Modal title='Import Question Definition' open forceRender onCancel={onClose} footer={null}>
            <Form autoComplete='off' onFinish={handleFinish} layout='vertical' form={form}>
                <Form.Item name='file' label='Question Definition JSON' getValueFromEvent={event => event.file} rules={[{ required: true, message: 'Please upload a question definition JSON file' }]}>
                    <Dragger {...draggerProps} aria-label='Submission files'>
                        <p className='ant-upload-drag-icon'>
                            <InboxOutlined />
                        </p>
                        <p className='ant-upload-text'>Click or drag file with submissions to this area</p>
                    </Dragger>
                </Form.Item>
                <div className='d-flex-end'>
                    <Form.Item className='mb-0'>
                        <Button
                            type='primary'
                            htmlType='submit'
                            block
                            loading={importQuestionDefinitionResult.isLoading}
                        >
                            Import
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}
